(function () {
  const CACHE_KEY = 'usd_rate_cache';
  const CACHE_HOURS = 12;
  const MARKUP = 1.30;
  const FALLBACK_RATE = 0.012;

  let cachedRate = null;

  async function getInrToUsdRate() {
    if (cachedRate) return cachedRate;
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      const isFresh = cached && (Date.now() - cached.timestamp) < CACHE_HOURS * 60 * 60 * 1000;
      if (isFresh) {
        cachedRate = cached.rate;
        return cachedRate;
      }

      const response = await fetch('https://api.frankfurter.dev/v1/latest?base=INR&symbols=USD');
      if (!response.ok) throw new Error('Rate fetch failed');
      const data = await response.json();
      cachedRate = data.rates.USD;

      localStorage.setItem(CACHE_KEY, JSON.stringify({ rate: cachedRate, timestamp: Date.now() }));
      return cachedRate;
    } catch (error) {
      console.warn('USD price: using fallback rate —', error);
      cachedRate = FALLBACK_RATE;
      return cachedRate;
    }
  }

  async function convertElement(el) {
    if (el.dataset.usdApplied === 'true') return;
    const inrMinorUnits = parseInt(el.dataset.inrPrice, 10);
    if (isNaN(inrMinorUnits)) return;

    const rate = await getInrToUsdRate();
    const usd = (inrMinorUnits / 100) * rate * MARKUP;

    el.textContent = '$' + usd.toFixed(2) + ' USD';
    el.dataset.usdApplied = 'true';
  }

  function convertAll(root = document) {
    root.querySelectorAll('[data-inr-price]:not([data-usd-applied="true"])').forEach(convertElement);
  }

  document.addEventListener('DOMContentLoaded', () => convertAll());

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('[data-inr-price]')) convertElement(node);
        node.querySelectorAll?.('[data-inr-price]').forEach(convertElement);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();